import React from "react";
import CheckmarkIcon from "../../../Layout/Icons/CheckmarkIcon";

const ShowGuides = ({ onToggleGuides, guidesVisible }) => {
  const handleOnClick = () => {
    onToggleGuides();
  };

  const selected = guidesVisible ? "selected" : "";

  return (
    <div className="control__container">
      <div className="control__title">Show Guides</div>
      <button
        className={`control__button button button--canvas button--border button--guides ${selected}`}
        onClick={handleOnClick}
      >
        {guidesVisible && <CheckmarkIcon />}
      </button>
    </div>
  );
};

export default ShowGuides;
